/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  FETCHING_REPORTS,
  FETCHED_REPORTS,
  FETCH_REPORTS_ERROR,
  FETCH_QLIK_SESSION_ERROR,
  FETCHED_REPORTS_STATUS
} from '../actions/actionTypes';

const initialReportsState = {
  isFetching: null,
  reports: [],
  error: null,
  sessionError: null,
  reportsEnabled: null
};

const qlikReportsReducer = (state = initialReportsState, action) => {
  switch (action.type) {
    case FETCHING_REPORTS:
      return Object.assign({}, state, { isFetching: true });
    case FETCHED_REPORTS:
      return Object.assign({}, state, { reports: action.payload.data, isFetching: false, error: null });
    case FETCH_REPORTS_ERROR:
      return Object.assign({}, state, { error: action.payload.data, isFetching: false });
    case FETCH_QLIK_SESSION_ERROR:
      return Object.assign({}, state, { sessionError: action.payload.data, isFetching: false });
    case FETCHED_REPORTS_STATUS:
      return Object.assign({}, state, { reportsEnabled: action.payload.data.reportingEnabled });
    default:
      return state;
  }
};

export default qlikReportsReducer;
